import Rusha from 'rusha';

export default function sha1 (data: string = ''){
  const hexHash = Rusha.createHash().update(data).digest('hex');
  return hexHash;
}